import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Campaign, FacebookComment, FacebookPost, FetchedAgent, FetchedCampaign } from '../../utils/interfaces';
import { SimpleTreeView, TreeItem, TreeView } from '@mui/x-tree-view';
import { Box, Card, CardContent, Typography } from '@mui/material';
import CampaignAnswer from './CampaignAnswer';

// Assuming FacebookComment and Campaign interfaces are correctly imported

interface Props {
  post: FacebookPost;
  selectedAgent: FetchedAgent;
  campaignId: string;
}

const renderTree = (comments: FacebookComment[]) => comments.map((comment) => (
    <TreeItem
      key={comment.id}
      itemId={comment.id}
      label={
        <Box>
          <Typography component="span" variant="body1" sx={{ fontWeight: 'bold', mr: 1 }}>
            {comment.author?.name}:
          </Typography>
          <Typography component="span" variant="body1">
            {comment.content}
          </Typography>
        </Box>
      }>
      {comment.comments && Array.isArray(comment.comments) ? renderTree(comment.comments) : null}
    </TreeItem>
  ));
  

const CommentTable = ({ campaignId, post, selectedAgent }: Props) => {
  const [selectedCommentId, setSelectedCommentId] = useState<string>("");

  const handleSelect = (event: React.SyntheticEvent, nodeIds: string) => {
    setSelectedCommentId(nodeIds);
  };

  const handleItemSelectionToggle = (
    event: React.SyntheticEvent,
    itemId: string,
    isSelected: boolean,
  ) => {
    if (isSelected) {
        setSelectedCommentId(itemId);
    }
  };
  const findCommentById = (comments: FacebookComment[], id: string): FacebookComment | undefined => {
    for (let comment of comments) {
      if (comment.id === id) {
        return comment;
      }
      if (comment.comments) {
        const found = findCommentById(comment.comments, id);
        if (found) return found;
      }
    }
  };

  const selectedComment = selectedCommentId ? findCommentById(post.comments, selectedCommentId) : null;

  return (
    <Box>
       <SimpleTreeView onItemSelectionToggle={handleItemSelectionToggle}>
        {renderTree(post.comments)}
      </SimpleTreeView>
      {selectedComment && (
        <Card sx={{ width: '600px', mt: 2 }}>
        <CardContent>
          <Typography variant="h5" component="div">
            <strong>{selectedComment.author?.name}</strong> {/* Making author's name bold */}
          </Typography>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            {selectedComment.content}
          </Typography>
          <CampaignAnswer campaignId={campaignId} agent={selectedAgent} commentId = {selectedComment.id} content={selectedComment.content} author={selectedComment.author ? selectedComment.author: {name:"", id:"-1"} } post={post} isOpen={selectedCommentId === selectedComment.id} />
          
        </CardContent>
      </Card>
      )}
    </Box>
  );
};

export default CommentTable;
